import { createAsyncThunk } from "@reduxjs/toolkit";
import { IEmployeeManagementResponse } from "models/Employee/employeeManagement.model";
import { ITokenModel } from "models/Login/token.model";
import { GetEmployee } from "services/employeeManagement.service";

// for Employee Management Page
export const getAgentsAsync = createAsyncThunk(
  "EmployeeManagement",
  async (empReq: ITokenModel): Promise<IEmployeeManagementResponse> => {
    try {
      const response = await GetEmployee(empReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
